module.exports = __webpack_public_path__ + "static/media/faq-jump-page.9894d702.svg";